import React from 'react';
import Select from 'react-select';

export interface Option {
  label: string;
  value: string | number;
}

// Full list of possible props at https://react-select.com/props

interface Props {
  backspaceRemovesValue?: boolean;
  className?: string;
  defaultValue?: string;
  disabled?: boolean;
  inputValue?: string;
  isClearable?: boolean;
  isMulti?: boolean;
  isSearchable?: boolean;
  loadingMessage?: () => string | null;
  menuPortal?: HTMLElement;
  options: ReadonlyArray<Option>;
  placeholder?: string;
  style?: {};
  value?: Array<Option> | Option;
  onChange: (param) => void;
}

const SimpleSelect: React.FC<Props> = ({ ...props }) => (
  <Select
    styles={styles}
    {...props}
  />
);

export default SimpleSelect;

const disabledStyles = {
  background: '#eee',
  border: '1px solid #d4d4d4',
  color: '#555',
  borderRadius: 3,
};

export const styles = {
  container: (provided, { isDisabled }) => ({
    ...provided,
    ...isDisabled ? { ...disabledStyles } : {},
    width: '100%',
    fontSize: '13px',
  }),

  control: (provided) => ({
    ...provided,
    minHeight: '28px',
    height: '28px',
    border: '2px solid #F4F4F4',
    boxShadow: 'none',

    ':hover': {
      borderColor: '#F4F4F4',
    },
  }),

  valueContainer: (provided) => ({
    paddingLeft: '4px',
  }),

  input: (provided) => ({
    ...provided,
    minHeight: '28px',
    height: '28px',
    margin: 0,
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '2px',
    minHeight: '28px',
    height: '28px',
  }),

  indicatorsContainer: (provided) => ({
    ...provided,
    minHeight: '28px',
    height: '28px',
  }),

  indicatorSeparator: () => ({
    display: 'none',
  }),

  option: (provided) => ({
    ...provided,
    display: 'flex',
    fontSize: 13,
    paddingLeft: 10,
    paddingTop: 4,
    paddingBottom: 4,
    boxSizing: 'border-box',
    overflow: 'hidden',
    cursor: 'pointer',

    ':hover': {
      backgroundColor: '#f1f1f1',
      color: '#41403b',
    },

    ':first-of-type': {
      borderTopRightRadius: 3,
      borderTopLeftRadius: 3,
    },

    ':last-child': {
      borderBottomRightRadius: 3,
      borderBottomLeftRadius: 3,
    },
  }),

  menuPortal: (provided) => ({
    ...provided,
    zIndex: 100000,
  }),
};
